import axios from "axios";
import config from "@/config/config.js";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Lance l'analyse d'une annonce (tâche en arrière-plan côté API) et renvoie l'id de la tâche
export async function startParse(url, notify = true) {
  const response = await axios.get(`${config.apiUrl}/offers/parse`, {
    params: { url, notify },
    timeout: 30000,
  });
  return response.data?.job_id || null;
}

// Attend la fin de la tâche d'analyse.
// Résultat : { status: "Completed" | "Failed" | "Timeout", offerId, error }
export async function waitForParse(jobId, { interval = 2000, timeout = 120000 } = {}) {
  if (!jobId) return { status: "Timeout", offerId: null, error: null };

  const deadline = Date.now() + timeout;
  while (Date.now() < deadline) {
    await sleep(interval);
    try {
      const { data } = await axios.get(`${config.apiUrl}/jobs/${jobId}`);
      if (data?.status === "Completed" || data?.status === "Failed") {
        return { status: data.status, offerId: data.offer_id || null, error: data.error || null };
      }
    } catch (error) {
      // 404 : tâche purgée ou inconnue ; on arrête d'attendre
      if (error.response?.status === 404) break;
    }
  }
  return { status: "Timeout", offerId: null, error: null };
}

// Raccourci : lance l'analyse puis attend son résultat
export async function parseAndWait(url, notify = true, options) {
  const jobId = await startParse(url, notify);
  return waitForParse(jobId, options);
}
